import { render, staticRenderFns } from "./ListSets.vue?vue&type=template&id=04561aca&"
import script from "./ListSets.vue?vue&type=script&lang=js&"
export * from "./ListSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports